import React from "react";

const Pagination = ({currentPage, totalPages, onPageChange, maxVisible = 5}) => {

    const getPageNumbers = () => {
        if(totalPages <= maxVisible + 2){
            return Array.from({length: totalPages}, (_, i) => i + 1);
        }

        const half = Math.floor(maxVisible / 2);
        let start = Math.max(2, currentPage - half);
        let end = Math.min(totalPages - 1, start + maxVisible - 1);

        if(end === totalPages - 1){
            start = Math.max(2, end - maxVisible + 1);
        }

        const pages = [];

        pages.push(1);

        if(start > 2){
            pages.push('left-ellipsis');
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        if (end < totalPages - 1) {
            pages.push('right-ellipsis');
        }

        if (totalPages > 1) {
            pages.push(totalPages);
        }

        return pages;
    };

    if (totalPages <= 1) return null;
 
  const pages = getPageNumbers();
 
  return (
    <nav>
      <ul className="pagination mb-0">
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button className="page-link" onClick={() => onPageChange(currentPage - 1)}>Previous</button>
        </li>
        {pages.map((page, idx) => {
          if (typeof page === 'string') {
            // Ellipsis
            return (
              <li key={page} className="page-item disabled">
                <span className="page-link">…</span>
              </li>
            );
          }
          return (
            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
              <button className="page-link" onClick={() => onPageChange(page)}>{page}</button>
            </li>
          );
        })}
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button className="page-link" onClick={() => onPageChange(currentPage + 1)}>Next</button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;